import { ExternalLink, FileSearch } from "lucide-react";
import { Badge } from "../../components/ui/Badge";

export default function ResearchBusinessBrief({ brief }) {
  if (!brief?.version) return null;
  const facts = brief.facts || [];
  const context = brief.local_context || {};
  return <section className="research-business-brief" aria-label="客户商业事实">
    <header><strong><FileSearch size={16} /> 客户商业事实</strong>
      <Badge tone={facts.length ? "info" : "neutral"}>{facts.length} 条原文支持</Badge></header>
    <p>{brief.notice}</p>
    {facts.length ? <div className="research-business-facts">{facts.map((fact, index) =>
      <article key={`${fact.source_id}-${fact.field}-${index}`}>
        <div><strong>{fact.label}</strong><Badge tone="neutral">{fact.evidence_level === "official_statement" ? "官网自述" : "外部来源陈述"}</Badge></div>
        <p>{fact.value}</p>
        <details><summary>查看原文依据</summary><blockquote>{fact.quote}</blockquote>
          <a href={fact.url} target="_blank" rel="noreferrer noopener">{fact.source_name || "查看来源"} <ExternalLink size={13} /></a>
          {fact.observed_at ? <small>采集于 {fact.observed_at}</small> : null}
        </details>
      </article>)}</div> : <p>{brief.extraction_status === "unavailable" ? "本轮商业事实提取暂未完成，请结合下方原始来源核对。" : "本轮尚未取得可引用的客户商业事实，不据此判断客户无价值。"}</p>}
    {context.clues?.length ? <details><summary>本轮使用了 {context.clues.length} 条富通／历史线索</summary>
      {context.clues.map((clue, i) => <p key={`${clue.reference}-${i}`}>{clue.kind === "crm" ? "富通" : "历史询盘"}：{clue.company_name || "公司待确认"} · {clue.website || clue.country || "待核实"}<small>{clue.reference} · 历史线索</small></p>)}
    </details> : null}
    {context.conflicts?.map((item) => <p key={item} className="research-business-conflict">{item}</p>)}
    {brief.next_actions?.length ? <details><summary>待补充与后续核对</summary><ul>{brief.next_actions.map((item) => <li key={item}>{item}</li>)}</ul></details> : null}
  </section>;
}
